import { Box, Container, IconButton, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";

import Parse from "../../API/ParseServer";
import { useParams } from "react-router-dom";
import Footer from "../../Components/Layout/Footer";
const Blog = () => {
  const params = useParams();
  const [blog, setBlog] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [secCount, setSecCount] = useState<number[]>([]);
  const [isLiked, setIsLiked] = useState();

  useEffect(() => {
    const fetchBlog = async () => {
      const query = new Parse.Query("Blog");
      const user = Parse.User.current();

      query.equalTo("objectId", params.blogId);
      try {
        const results = await query.find();
        if (results.length > 0) {
          setBlog(results[0]);
          console.log(secCount);
          for (
            let index = 1;
            index <= results[0].get("sectionCounter");
            index++
          ) {
            setSecCount((current) => {
              if (
                !current.find(
                  (cur: any) => cur === results[0].get("sectionCounter")
                )
              )
                return [...current, index];
              else return [...current];
            });
          }
          if (user)
            setIsLiked(
              results[0].get("likeUsers")
                ? results[0].get("likeUsers").includes(user.id)
                : false
            );
        } else {
          throw new Error("Blog not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [params.blogId]);
  const [likeError, setLikeError] = useState("");

  const likeHandler = async () => {
    const user = Parse.User.current();
    if (user) {
      let response: any;
      try {
        response = await Parse.Cloud.run("toggleBlogLike", {
          blogId: params.blogId,
          userId: user.id,
        });
      } catch (error: any) {
        console.error(error.message);
        alert(error.message);
      } finally {
        if (response) setIsLiked(response.isLiked);
      }
    } else {
      setLikeError("You need to login first!");
      setTimeout(() => {
        setLikeError("");
      }, 1000);
    }
  };
  const copyHandler = () => {
    window.navigator.clipboard.writeText(document.URL);
  };
  return (
    <Fragment>
      <Box
        sx={{
          width: "100%",
          color: "white",
          pb: 8,
          position: "relative",
          height: "30rem",
          // backgroundColor: "gray",
        }}
      >
        <Container>
          <Typography variant="h4" component="h1" sx={{ pt: 17 }}>
            {blog && blog.get("title")}
          </Typography>
          <br />
          <br />
          <Typography variant="h6">
            {blog && blog.get("publishDate").toDateString()} By:{" "}
            {blog && blog.get("author")}
          </Typography>
          <br />
          {blog &&
            blog.get("topics").map((topic: any) => (
              <Typography
                sx={{
                  display: "inline",
                  backgroundColor: "#863a1d",
                  p: "8px 20px",
                  color: "white",
                  fontWeight: "1000",
                  mr: 2,
                }}
              >
                {topic}
              </Typography>
            ))}

          {isLiked ? (
            <IconButton aria-label="remove to favorites" onClick={likeHandler}>
              <FavoriteIcon sx={{ color: "#8d462b", fontSize: "35px" }} />
            </IconButton>
          ) : (
            <IconButton aria-label="add to favorites" onClick={likeHandler}>
              <FavoriteBorderOutlinedIcon
                sx={{ color: "white", fontSize: "35px" }}
              />
            </IconButton>
          )}
          {likeError && (
            <Typography
              variant="caption"
              sx={{ position: "absolute", bottom: "3rem", left: "39rem" }}
            >
              {likeError}
            </Typography>
          )}
          <IconButton onClick={copyHandler}>
            <ShareOutlinedIcon sx={{ color: "white", fontSize: "35px" }} />
          </IconButton>
        </Container>
        {blog && blog.get("banner") && (
          <img
            src={blog.get("banner").url()}
            alt="banner"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -5,
              height: "30rem",
              width: "100%",
            }}
          />
        )}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            height: "30rem",
            width: "100%",
            backgroundColor: "black",
            opacity: 0.5,
          }}
        ></Box>
      </Box>

      <Container sx={{ pb: 5, mb: 20 }}>
        {blog && blog.get("abstract") && (
          <Fragment>
            <Box
              sx={{
                // marginTop: 15,
                borderBottom: "2px solid #dad9da",
                width: "100%",
                mt: 10,
                mb: 5,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  display: "inline",
                  boxShadow: "0 2px #0a0a0a",
                  paddingBottom: "4px",
                  fontWeight: "1000",
                }}
              >
                Abstract
              </Typography>
            </Box>
            <Container maxWidth="lg">
              {blog &&
                blog.get(`abstract`).map((item: any) => (
                  <Typography>
                    {item} <br />
                    <br />
                  </Typography>
                ))}
            </Container>
          </Fragment>
        )}
        <Box
          sx={{
            borderBottom: "2px solid #dad9da",
            width: "100%",
            mt: 10,
            mb: 5,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              display: "inline",
              boxShadow: "0 2px #0a0a0a",
              paddingBottom: "4px",
              fontWeight: "1000",
            }}
          >
            Main Article
          </Typography>
        </Box>
        {secCount.map((sec) =>
          sec % 2 === 0 ? (
            <Container>
              <img
                src={blog.get(`section${sec}`).url()}
                alt=""
                style={{ width: "100%", marginTop: "1.5rem" }}
              />
            </Container>
          ) : (
            <Fragment>
              <Container maxWidth="lg">
                {blog &&
                  blog.get(`section${sec}`).map((item: any, ind: any) =>
                    ind % 2 === 0 ? (
                      item ? (
                        <Fragment>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: "1000", marginTop: "1.5rem" }}
                          >
                            {item}
                          </Typography>
                          <br />
                        </Fragment>
                      ) : (
                        <br />
                      )
                    ) : item ? (
                      <Typography>{item}</Typography>
                    ) : (
                      <br />
                    )
                  )}
              </Container>
            </Fragment>
          )
        )}
      </Container>
    </Fragment>
  );
};

export default Blog;
